import * as types from "./actionTypes";

const initialState = {
  employees: [],
  leaveTypes: [],
  leaveBalance: [],
  leaveExists: null,
  weekOfDates: [],
  markerPendingList: [],
  employee_leavetypes: [],
  markerCancelList:[],
  absentList: [],
  loading: false,
  error: null,
  success: false,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    // Employee
    case types.FETCH_EMPLOYEE_LIST_REQUEST:
      return { ...state, loading: true, error: null, success: false };
    case types.FETCH_EMPLOYEE_LIST_SUCCESS:
      return { ...state, loading: false, employees: action.payload.data, success: false };
    case types.FETCH_EMPLOYEE_LIST_FAILURE:
      return { ...state, loading: false, error: action.payload, success: false };

    // Leave Type
    case types.FETCH_LEAVE_TYPE_REQUEST:
      return { ...state, loading: true, error: null, success: false };
    case types.FETCH_LEAVE_TYPE_SUCCESS:
      return { ...state, loading: false, leaveTypes: action.payload.data, success: false };
    case types.FETCH_LEAVE_TYPE_FAILURE:
      return { ...state, loading: false, error: action.payload , success: false};

    // Leave Balance
    case types.FETCH_LEAVE_BALANCE_REQUEST:
      return { ...state, loading: true, error: null, success: false };
    case types.FETCH_LEAVE_BALANCE_SUCCESS:
      return { ...state, loading: false, leaveBalance: action.payload.data , success: false};
    case types.FETCH_LEAVE_BALANCE_FAILURE:
      return { ...state, loading: false, error: action.payload , success: false};

    // Check Leave Exists
    case types.CHECK_LEAVE_EXISTS_REQUEST:
      return { ...state, loading: true, error: null, success: false };
    case types.CHECK_LEAVE_EXISTS_SUCCESS:
      return { ...state, loading: false, leaveExists: action.payload.data, success: false };
    case types.CHECK_LEAVE_EXISTS_FAILURE:
      return { ...state, loading: false, error: action.payload, success: false };

    // Week of Dates
    case types.FETCH_WEEK_OF_DATES_REQUEST:
      return { ...state, loading: true, error: null , success: false};
    case types.FETCH_WEEK_OF_DATES_SUCCESS:
      return { ...state, loading: false, weekOfDates: action.payload , success: false};
    case types.FETCH_WEEK_OF_DATES_FAILURE:
      return { ...state, loading: false, error: action.payload, success: false };

    case types.APPLY_TAB_REQUEST:
      return { ...state, loading: true, error: null, success: null, success: false };

    case types.APPLY_TAB_SUCCESS:
      return { ...state, loading: false, success: action.payload, error: null , success: true};

    case types.APPLY_TAB_FAILURE:
      return { ...state, loading: false, error: action.payload, success: null, success: false };

     // 🔹 Pending List
    case types.FETCH_MARKER_PENDING_LIST_REQUEST:
      return { ...state, loading: true, error: null, success: false };
    case types.FETCH_MARKER_PENDING_LIST_SUCCESS:
      return { ...state, loading: false, markerPendingList: action.payload.data, success: false };
    case types.FETCH_MARKER_PENDING_LIST_FAILURE:
      return { ...state, loading: false, error: action.payload, success: false };

    // 🔹 Approve
    case types.MARKER_APPROVE_REQUEST:
      return { ...state, loading: true, error: null, success: false };
    case types.MARKER_APPROVE_SUCCESS:
      return { ...state, loading: false, success: true };
    case types.MARKER_APPROVE_FAILURE:
      return { ...state, loading: false, error: action.payload, success: false };

    // 🔹 Cancel List
    case types.FETCH_MARKER_CANCEL_LIST_REQUEST:
      return { ...state, loading: true, error: null, success: false };

    case types.FETCH_MARKER_CANCEL_LIST_SUCCESS:
      return { ...state, loading: false, markerCancelList: action.payload.data, success: false };

    case types.FETCH_MARKER_CANCEL_LIST_FAILURE:
      return { ...state, loading: false, error: action.payload, success: false };

    // 🔹 Cancel Marker
    case types.MARKER_CANCEL_REQUEST:
      return { ...state, loading: true, error: null, success: false };

    case types.MARKER_CANCEL_SUCCESS:
      return { ...state, loading: false, success: true };

    case types.MARKER_CANCEL_FAILURE:
      return { ...state, loading: false, error: action.payload, success: false };

     // 🔹 Fetch Absent List
    case types.FETCH_ABSENT_LIST_REQUEST:
      return { ...state, loading: true, error: null, success: false };

    case types.FETCH_ABSENT_LIST_SUCCESS:
      return { ...state, loading: false, absentList: action.payload.data, success: false };

    case types.FETCH_ABSENT_LIST_FAILURE:
      return { ...state, loading: false, error: action.payload, success: false };

    // 🔹 Update LOP
    case types.ABSENT_LOP_UPDATE_REQUEST:
    case types.ABSENT_LEAVE_UPDATE_REQUEST:
    case types.ABSENT_OD_UPDATE_REQUEST:
    case types.ABSENT_WEEKOFF_UPDATE_REQUEST:
      return { ...state, loading: true, error: null, success: false };

    case types.ABSENT_LOP_UPDATE_SUCCESS:
    case types.ABSENT_LEAVE_UPDATE_SUCCESS:
    case types.ABSENT_OD_UPDATE_SUCCESS:
    case types.ABSENT_WEEKOFF_UPDATE_SUCCESS:
      return { ...state, loading: false, success: true };

    case types.ABSENT_LOP_UPDATE_FAILURE:
    case types.ABSENT_LEAVE_UPDATE_FAILURE:
    case types.ABSENT_OD_UPDATE_FAILURE:
    case types.ABSENT_WEEKOFF_UPDATE_FAILURE:
      return { ...state, loading: false, error: action.payload, success: false };

    // Check Employee Leave Type
    case types.FETCH_EMPLOYEE_LEAVE_TYPE_REQUEST:
      return { ...state, loading: true, error: null, success: false };
    case types.FETCH_EMPLOYEE_LEAVE_TYPE_SUCCESS:
      return { ...state, loading: false, employee_leavetypes: action.payload, success: false };
    case types.FETCH_EMPLOYEE_LEAVE_TYPE_FAILURE:
      return { ...state, loading: false, error: action.payload, success: false };
      
    case "CLEAR_ABSENT_ERROR":
      return {
        ...state,
        error: null,
      };

    default:
      return state;
  }
}
